/**
 * Newsletter UI Logic
 * All UI-related logic: form state management
 */

import { useState, useCallback } from 'react';

/**
 * Hook for managing newsletter subscription form state
 * @param {function} onSubmit - Form submission handler
 * @returns {{subscriptionData: object, handleInputChange: function, handleSubmit: function, isSubmitting: boolean}}
 */
export function useNewsletterForm(onSubmit = null) {
  const [subscriptionData, setSubscriptionData] = useState({
    email: '',
    firstName: '',
    lastName: '',
    company: '',
    role: '',
    interests: {
      productUpdates: false,
      technicalInsights: false,
      industryNews: false,
      events: false,
      partnerNews: false
    },
    frequency: 'weekly'
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleInputChange = useCallback((e) => {
    const { name, value, type, checked } = e.target;
    
    if (type === 'checkbox' && name.startsWith('interests.')) {
      const interestKey = name.split('.')[1];
      setSubscriptionData(prev => ({
        ...prev,
        interests: {
          ...prev.interests,
          [interestKey]: checked
        }
      }));
    } else {
      setSubscriptionData(prev => ({
        ...prev,
        [name]: type === 'checkbox' ? checked : value
      }));
    }
  }, []);

  const handleSubmit = useCallback(async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      if (onSubmit) {
        await onSubmit(subscriptionData);
      } else {
        console.log('Newsletter subscription:', subscriptionData);
      }
    } catch (error) {
      console.error('Error subscribing to newsletter:', error);
      throw error;
    } finally {
      setIsSubmitting(false);
    }
  }, [subscriptionData, onSubmit]);

  return {
    subscriptionData,
    handleInputChange,
    handleSubmit,
    isSubmitting
  };
}


